<template>
    <v-row>
        <v-col cols="12" v-if="pagos.length > 0">
            <v-row>
                <v-col sm="6" xs="12" md="4" class="order-1">
                    <v-btn block color="green" class="white--text font-weight-bold" small raised elevation="4">
                        Total seleccionado: <span class="font-weight-bold text-h6"> {{ getTotalSaldoSelectedNatural }}
                        </span>
                        <v-icon right @click.prevent="copyClipboardSaldoSelected(getTotalSaldoSelectedNatural)">fas
                            fa-copy</v-icon>
                    </v-btn>
                </v-col>
                <v-col sm="6" xs="12" md="8" class="d-flex justify-end order-2">
                    <v-btn color="orange" class="mr-2" @click.prevent="enableAll()" small raised elevation="4">
                        <v-icon left>fas fa-check-square</v-icon> Habilitar todos
                    </v-btn>

                    <v-btn color="primary" @click.prevent="asignarPagos()" small raised elevation="4">
                        <v-icon left>fas fa-dollar-sign</v-icon> Autoasignar pagos
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>

        <v-col cols="12" class="mt-0">
            <v-simple-table fixed-header height="auto" dense class="elevation-1">
                <template v-slot:default>
                    <thead class="text-center primary">
                        <tr>
                            <th class="text-left">Habilitar</th>
                            <th class="text-left">Folio entrada</th>
                            <th class="text-left">Fecha entrada</th>
                            <th class="text-left">Total</th>
                            <th class="text-left">Abonado</th>
                            <th class="text-left">Saldo</th>
                            <th class="text-left">Monto a Pagar</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in pagos" :key="item.id" v-if="pagos.length > 0">
                            <td>
                                <v-checkbox v-model="item.activo"></v-checkbox>
                            </td>

                            <td>{{ item.ticketFolio }}</td>
                            <td>{{ item.fechaEntradaNatural }}</td>

                            <td>
                                <v-text-field :value="item.finalTotalNatural" type="text"
                                    class="font-weight-medium text-h6 green--text" persistent-hint disabled>
                                </v-text-field>
                            </td>

                            <td>
                                <v-text-field :value="item.abonadoNatural" type="text"
                                    class="font-weight-medium text-h6 green--text" persistent-hint disabled>
                                </v-text-field>
                            </td>

                            <td>
                                <v-text-field :value="item.saldoNatural" type="text"
                                    class="font-weight-medium text-h6 green--text" persistent-hint disabled>
                                </v-text-field>
                            </td>

                            <td>
                                <ValidationProvider
                                    :rules="!item.activo ? '' : 'required|min_value:1|max_value:' + item.saldo+'' "
                                    v-slot="{ errors, valid }" :immediate="true">
                                    <v-text-field v-model.number="item.payedAmount" :value="item.payedAmount"
                                        type="number" class="mt-2 font-weight-black text-h6" outlined persistent-hint
                                        required min="1" :max="item.saldo" placeholder="0.00" :error-messages="errors"
                                        :success="valid" :disabled="!item.activo">
                                        <!-- @input="(e) => changeItem(e, index, 'cantidad')" -->
                                    </v-text-field>
                                </ValidationProvider>
                            </td>
                        </tr>

                        <tr v-if="pagos.length == 0">
                            <td colspan="7">
                                <v-alert block border="left" colored-border type="success" elevation="2"
                                text dense
                                class=" mt-1 green--text font-weight-bold text-h5 text-center">
                                    {{ 
                                        (pago.providerId == 0 || pago.providerId == null)
                                        ? 'Favor de seleccionar un proveedor para la consulta de pagos'
                                        : 'No hay pagos pendientes para el proveedor seleccionado'
                                    }}
                                </v-alert>
                            </td>
                        </tr>
                        <tr v-else>
                            <td colspan="5"></td>
                            <td>
                                <v-alert border="right" colored-border elevation="2" outlined text dense
                                    class=" mt-2 green--text font-weight-bold text-h5">
                                    Total a pagar:
                                </v-alert>
                            </td>
                            <td colspan="2">
                                <v-alert border="right" colored-border elevation="2" outlined text dense
                                    class=" mt-2 green--text font-weight-bold text-h5">
                                    {{ getPayedAmountTotalNatural }}
                                </v-alert>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
    </v-row>
</template>

<script>
    import EntradaDataService from '@/service/entrada/EntradaDataService';
import { getFormatCurrency } from '@/utils/CurrencyUtil';

    export default {
        name: 'AddPayment',
        props: {
            pago: { type: Object, required: true }
        },
        data() {
            return {
                pagos: []
            }
        },
        methods: {
            getEntradaProveedor(providerId) {
                EntradaDataService.findByCreditProvider(providerId).then(response => {
                    const info = response.data;
                    this.pagos = info.map(item => {
                        return {
                            ...item,
                            providerId,
                            entradaId: item.id,
                            payedAmount: 0,
                            activo: false,
                        }
                    });
                })
            },
            deletePayment(item, index) {
            },
            asignarPagos() {
                let amount = this.pago.payedAmount;
                // set payedAmount to 0
                this.pagos.forEach(item => item.payedAmount = 0);
                this.pagos.filter(payment => payment.activo == true).forEach(payment => {
                    if(amount == 0){
                        payment.payedAmount = 0;
                        payment.activo = false;
                    }
                    if(amount > payment.saldo){
                        payment.payedAmount = payment.saldo;
                        amount = amount - payment.saldo;
                    } else {
                        payment.payedAmount = amount;
                        amount = 0;
                    }
                })
            },
            enableAll() {
                this.pagos.forEach(item => item.activo = true)
            },
            copyClipboardSaldoSelected(value) {
                if(!value) return;
                navigator.clipboard.writeText(value);
            }
        },
        watch: {
            'pago.providerId': function(newValue) {
                if (newValue != null) {
                    this.getEntradaProveedor(newValue)
                }
            },
            'pagos': function(newValue) {
                this.$emit('addPagos', newValue)
            }
        },
        computed: {
            getPayedAmountTotal() {
                const payments = this.pago.payments.filter(payment => payment.activo == true );
                return payments.reduce((total, payment) => total + payment.payedAmount, 0);
            },
            getPayedAmountTotalNatural() {
                return getFormatCurrency(this.getPayedAmountTotal, '$ ');
            },
            getTotalSaldoSelectedNatural(){
                const total = this.pagos.filter(payment => payment.activo == true).reduce((acc, item) => acc + item.saldo, 0);
                return getFormatCurrency(total, '$ ');
            }
        }
    }
</script>